import { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

export default function OfferPriceTextArea(props) {
  const textareaRef = useRef(null);

  const resize = () => {
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
  };

  useEffect(() => {
    resize();
  }, [props.value]);

  return (
    <Form.Control
      className="fs-6"
      as="textarea"
      ref={textareaRef}
      rows={1}
      {...props}
      onInput={resize}
      style={{
        border: 0,
        padding: 0,
        boxShadow: "none",
        resize: "none",
        overflow: "hidden",
        background: "transparent",
        whiteSpace: "pre-wrap",
        ...props.style,
      }}
    />
  );
}
